// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"docs_wrapper__4idVQ"};